<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12 mb-4">
        <!-- Card Skeleton -->
        <div class="card shadow mb-4">
          <!-- Card Header -->
          <div class="card-header py-3 d-flex justify-content-between align-items-center">
            <div class="skeleton-box" style="height: 24px; width: 150px;"></div>
            <div class="skeleton-box" style="height: 36px; width: 120px; border-radius: 4px;"></div>
          </div>

          <!-- Card Body -->
          <div class="card-body">
            <!-- Filter Section (if hasFilters) -->
            <div v-if="hasFilters" class="row align-items-end mb-3">
              <div v-for="n in filterCount" :key="n" class="col-md-3">
                <div class="skeleton-box mb-2" style="height: 16px; width: 80px;"></div>
                <div class="skeleton-box" style="height: 38px; width: 100%;"></div>
              </div>
            </div>

            <!-- Table Skeleton -->
            <div class="table-responsive">
              <table class="table trips-table">
                <thead class="thead-light">
                  <tr>
                    <th v-for="n in columnCount" :key="n" scope="col">
                      <div class="skeleton-box" style="height: 20px; width: 80%;"></div>
                    </th>
                    <th v-if="hasActions" scope="col">
                      <div class="skeleton-box" style="height: 20px; width: 80px;"></div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in rowCount" :key="row">
                    <td v-for="col in columnCount" :key="col">
                      <div class="skeleton-box" :style="`height: 18px; width: ${getRandomWidth()}%;`"></div>
                    </td>
                    <td v-if="hasActions">
                      <div class="d-flex gap-2">
                        <div class="skeleton-box" style="height: 32px; width: 32px; border-radius: 4px;"></div>
                        <div class="skeleton-box" style="height: 32px; width: 32px; border-radius: 4px;"></div>
                        <div class="skeleton-box" style="height: 32px; width: 32px; border-radius: 4px;"></div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Card Footer (Pagination) -->
          <div class="card-footer">
            <div class="d-flex justify-content-between align-items-center">
              <div class="skeleton-box" style="height: 16px; width: 120px;"></div>
              <div class="d-flex gap-2">
                <div class="skeleton-box" style="height: 36px; width: 36px; border-radius: 4px;"></div>
                <div class="skeleton-box" style="height: 36px; width: 36px; border-radius: 4px;"></div>
                <div class="skeleton-box" style="height: 36px; width: 36px; border-radius: 4px;"></div>
                <div class="skeleton-box" style="height: 36px; width: 36px; border-radius: 4px;"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardSkeleton",
  props: {
    columnCount: {
      type: Number,
      default: 3,
    },
    rowCount: {
      type: Number,
      default: 8,
    },
    hasActions: {
      type: Boolean,
      default: true,
    },
    hasFilters: {
      type: Boolean,
      default: false,
    },
    filterCount: {
      type: Number,
      default: 3,
    },
  },
  methods: {
    getRandomWidth() {
      // Returns a width between 50% and 95%
      return Math.floor(Math.random() * 45) + 50;
    },
  },
};
</script>

<style scoped>
.skeleton-box {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.gap-2 {
  gap: 0.5rem;
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .skeleton-box {
    background: linear-gradient(90deg, #2a2a2a 25%, #3a3a3a 50%, #2a2a2a 75%);
    background-size: 200% 100%;
  }
}
</style>
